import { create } from "zustand";

// Session-scoped record of which assistant chat widgets have already been
// actioned (confirmed / deleted / dismissed / sent / cancelled), keyed by a
// stable per-widget id. The Mantine v5 drawer unmounts its children on close,
// so the widgets' own useState is lost on reopen; reading the terminal status
// from here lets a remounted widget restore its completed/disabled view and
// keeps the user from firing the same mutation twice.
export const useAssistantWidgetStatus = create((set) => ({
  statusByKey: {},
  markStatus: (key, status) =>
    set((state) => ({
      statusByKey: { ...state.statusByKey, [key]: status },
    })),
  clearStatus: (key) =>
    set((state) => {
      const next = { ...state.statusByKey };
      delete next[key];
      return { statusByKey: next };
    }),
}));
